import { render } from "./ShowTasks.vue?vue&type=template&id=2ed30f97&scoped=true"
import script from "./ShowTasks.vue?vue&type=script&lang=js"
export * from "./ShowTasks.vue?vue&type=script&lang=js"

import "./ShowTasks.vue?vue&type=style&index=0&id=2ed30f97&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed30f97"]])

export default __exports__